export enum MenuModes {
    filter = 'filter',
    view   = 'view3d',
}